import { styled } from '@mui/material';

export const FooterContainer = styled('footer')`
  width: 100%;
  background-color: ${(props) => props.theme.palette.primary.main};
`;

export const FooterContainerAMP = styled('footer')`
  width: 100%;
  background-color: #0f132a;
  padding: 60px 16px;

  a {
    color: #fff;
  }

  .container {
    width: 100%;
    padding: 0;
    color: #fff;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    text-transform: uppercase;
    margin-bottom: 2rem;
  }

  @media (max-width: 950px) {
    .container {
      grid-template-columns: 1fr 1fr 1fr 1fr;
    }
  }

  @media (max-width: 760px) {
    .container {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }

  @media (max-width: 600px) {
    .container {
      grid-template-columns: 1fr 1fr;
    }
  }

  @media (max-width: 350px) {
    .container {
      grid-template-columns: 1fr;
    }
  }

  ul {
    padding-left: 0;
    padding-right: 0;
  }

  li {
    list-style-type: none;
  }

  .containerli {
    list-style: none;
    margin-top: 1rem;
  }

  .containerli:first-child {
    margin-top: 0;
  }

  .containerli a {
    font-size: 12px;
    color: #fff;
    text-decoration: none;
  }

  .div-terms {
    width: 100%;
    display: grid;
    align-items: flex-start;
    column-gap: 1rem;
    grid-template-columns: 1fr 6fr 2fr;

    margin-top: 1rem;
  }

  .div-terms small {
    color: #fff;
    font-size: 0.7rem;
  }

  @media (max-width: 1300px) {
    .div-terms {
      grid-template-columns: 1fr 5fr 2fr;
    }
  }

  @media (max-width: 1150px) {
    .div-terms {
      grid-template-columns: 1fr 4fr 2fr;
    }
  }

  @media (max-width: 1000px) {
    .div-terms {
      grid-template-columns: 1fr;
      grid-template-rows: 0.5fr 3fr 0.5fr;
      align-items: center;
    }
  }

  @media (max-width: 960px) {
    .div-terms {
      margin-top: 0;
    }
  }

  @media (max-width: 570px) {
    .div-terms {
      grid-template-columns: 1fr;
      grid-template-rows: 1fr 4fr 1fr;
      align-items: center;
    }
  }

  .socialItemContainer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .socialItem {
    margin-left: 10px;
    height: 45px;
    width: 45px;
    cursor: pointer;
  }
`;
